import { ApiDownloadCaller } from "../../../services/ApiDownloadCaller";
import { NZipFiles } from "./NZipFiles";
import ZipAttachmentFiles from "../../../services/ZipAttachmentFiles"; // import endpoint

// DOWNLOAD ZIP FILES, OTHER EXTENSIONS MIGHT REQUIRE CHANGES
//
// for zip files responseType: "blob" is required

export const NDownloadZip = async (attachment) => {
  const zipAttachmentFiles = new ZipAttachmentFiles(ApiDownloadCaller());

  try {
    const data = await zipAttachmentFiles.callApi(attachment); // switch for new endpoint if needed
    NZipFiles(data, attachment);
  } catch (err) {
    console.log(err);
  }
};
